<template>
  <div class="">
    <slot name="title"></slot>
    <template v-if="!isSubmitted">
      <slot name="info"> </slot>
      <div
        class="m-auto w-[316px] md:w-[660px] lg:w-[425px] xl:w-[525px] text-brand-black-secondary"
      >
        <div class="pt-5 flex flex-col gap-y-3">
          <a :href="uaePassAuthLink" class="flex justify-center px-12">
            <img
              src="@/assets/pngs/UAEPASS_Sign_up_Btn_Outline_Active.png"
              alt="UAE Pass login button (dark)"
              class="max-w-72 ltr:block rtl:hidden"
            />
            <img
              src="@/assets/pngs/AR_UAEPASS_Sign_up_Btn_Outline_Active.png"
              alt="UAE Pass login button (dark)"
              class="max-w-72 ltr:hidden rtl:block"
            />
          </a>
          <small class="w-full text-center px-12">{{ $t('smartPassLoginMessage') }}</small>
        </div>
        <div class="flex items-center gap-x-3 my-[30px]">
          <div class="border-b-[1px] border-current flex-1 h-1"></div>
          <span class="flex-shrink text-sm text-center pt-1.5">
            {{ $t('OR_login') }}
          </span>
          <div class="border-b-[1px] border-current flex-1 h-1"></div>
        </div>
        <div class="w-full flex justify-center">
          <Form
            class="w-full flex flex-col gap-3"
            v-slot="{ resetForm, validate }"
            @submit="(values) => onSubmit(values, validate, resetForm)"
          >
            <div class="flex gap-1 flex-col">
              <Field
                :rules="requiredRule && validEmail"
                ref="email"
                validate-on-input
                validate-on-change
                validate-on-blur
                name="email"
                v-slot="{ field, errors: errs }"
              >
                <TextInput
                  :field="field"
                  :errors="errs"
                  :placeholder="$t('email')"
                  :max-length="60"
                  :label="$t('email')"
                  label-class="w-full"
                  class="w-full"
                  direction="flex-col"
                  @on-blur="emailNotInUse"
                >
                </TextInput>
              </Field>
              <fieldset class="border-2 border-primary rounded p-4 flex flex-col gap-y-5">
                <legend class="px-2">{{ $t('verifyApplicant') }}</legend>
                <Field :rules="requiredRule" name="recaptchaResponse" v-slot="{ handleChange }">
                  <GRecaptcha
                    :key="rando"
                    ref="gRecaptchaRef"
                    class="flex justify-center"
                    @successCallback="(args) => handleChange('recaptchaResponse', args)"
                  ></GRecaptcha>
                </Field>
              </fieldset>
            </div>
            <div class="w-full flex justify-end">
              <button
                class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
              >
                <div class="p-2 bg-primary rounded-s-md">
                  <faDiskette class="w-4 fill-white"></faDiskette>
                </div>
                <span class="w-full text-center">
                  {{ $t('Confirm') }}
                </span>
                <div class="p-0.5"></div>
              </button>
            </div>
          </Form>
        </div>
      </div>
    </template>
    <div v-else class="pt-12 soar-container flex justify-center gap-y-2">
      <div class="max-w-[36rem] alert-success w-full p-3 border rounded-md">
        <p class="">{{ $t('EmailSentAfterRegistrationVerfiy') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import faDiskette from '@/assets/icons/faDiskette.svg?component'
import GRecaptcha from '@/components/GRecaptcha/index.vue'
import TextInput from '@/components/SimpleForm/TextInput.vue'
import { isValidEmail } from '@/composables/useRuleHandler.js'
import axiosInstance from '@/services'
import { notify } from 'notiwind'
import { Field, Form } from 'vee-validate'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps({ isSubmitted: Boolean })

const emit = defineEmits('onSubmit')

const i18n = useI18n()

const email = ref()
const emailAlreadyUsed = ref(false)
const uaePassAuthLink = ref('')

function requiredRule(value) {
  if (!`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

function validEmail(value) {
  return (!!value && isValidEmail(value)) || i18n.t('INVALID_EMAIL')
  // return !!value && isValidEmail(value) ? true
}

async function emailNotInUse() {
  const { value, setErrors } = email.value
  if (!value) return
  const path = ['/api/user/username', value, 'isExist']
  const isExist = await axiosInstance.get(path.join('/'), { preventLoadingAnimation: true })

  emailAlreadyUsed.value = isExist
  if (isExist) {
    setErrors('EMAIL_ALREADY_USED')
    return
  }

  return true
}

const generateUAEPassAuthLink = () => {
  return `${
    import.meta.env.VITE_UAEPASS_ENDPOINTS
  }/authorize?response_type=code&client_id=sandbox_stage&scope=urn:uae:digitalid:profile:general&state=HnlHOJTkTb66Y5H&redirect_uri=${
    location.origin
  }/auth/pass&acr_values=urn:safelayer:tws:policies:authentication:level:low 
`
}
uaePassAuthLink.value = generateUAEPassAuthLink()

const onSubmit = async (form) => {
  if (!form.recaptchaResponse) {
    notify(
      {
        group: 'error',
        title: i18n.t('captchaNotProcessed')
      },
      1000 * 8
    )
    return
  }

  if (emailAlreadyUsed.value) {
    notify(
      {
        group: 'error',
        title: i18n.t('EMAIL_ALREADY_USED')
      },
      1000 * 8
    )
    return
  }

  emit('onSubmit', form)
}
</script>

<style lang="scss" scoped></style>
